<template>
    <div class="table">
        <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
            :header-cell-style="headCellStyle" :height="tableHeight">
            <el-table-column prop="mark" :label="$t('integration.sign')" width="80">
                <template #default="{ row }">
                    <i style="line-height: 30px; margin-right: 5px" :class="storeFn(row, 'isStore', 'icon')"
                        :title="storeFn(row, 'isStore', 'text')"></i>
                    <i :style="{
                        'line-height': '30px',
                        color: row.isEx === 1 ? 'red' : '#00f583'
                    }" :class="exFn(row, 'isEx', 'icon')" :title="exFn(row, 'isEx', 'text')"></i>
                </template>
            </el-table-column>
            <el-table-column prop="collectTime" :label="$t('integration.acquisition_time')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span style="line-height: 30px">{{ $timetransition(row['collectTime']) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('integration.record_time')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span style="line-height: 30px">{{ $timetransition(row['createTime']) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="val" :label="$t('integration.detection_value')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span :class="classFn(row)">{{ unitFn(row['val'], 'no') }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('integration.monitoring_interval')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ unitFn(row, 'area') }}</span>
                </template>
            </el-table-column>
        </el-table>
        <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
            :limit.sync="SearchForm.iDisplayLength" :iDisplayLength="SearchForm.iDisplayLength"
            @pagination="getListFn('async')" :pageSizes="pageSizes"></Pagination>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        total: {
            type: Number,
            default: 0
        },
        unitText: {
            type: String,
            default: ''
        },
        tableData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tableHeight: 'calc(100% - 60px)',
            SearchForm: {
                iDisplayStart: 0,
                iDisplayLength: 5
            },
            pageSizes: [5, 20, 50, 100],
            storeArray: [
                {
                    id: 1,
                    text: $t('integration.real_time_data_collection'),
                    icon: 'iconfont icon-shishijiankong'
                },
                {
                    id: 2,
                    text: $t('integration.store_collected_data'),
                    icon: 'iconfont icon-yuncunchu'
                }
            ],
            abArray: [
                {
                    id: 1,
                    text: $t('integration.abnormal'),
                    icon: 'el-icon-warning'
                },
                {
                    id: 2,
                    text: $t('integration.normal'),
                    icon: 'el-icon-success'
                }
            ]
        };
    },
    methods: {
        storeFn(row, key, str) {
            let param = '';
            if (row[key] === 0) {
                param = this.storeArray[0][str];
            } else {
                param = this.storeArray[1][str];
            }
            return param;
        },
        exFn(row, key, str) {
            let param = '';
            if (row[key] === 1) {
                param = this.abArray[0][str];
            } else {
                param = this.abArray[1][str];
            }
            return param;
        },
        unitFn(val, str) {
            if (str === 'no') {
                return `${val}${this.unitText}`;
            } else {
                if (!val.min && val.min !== 0 && !val.max && val.max !== 0) return ' ';
                return `${val.min || val.min === 0 ? val.min : ' '}${this.unitText} ~ ${val.max || val.max === 0 ? val.max : ' '}${this.unitText}`;
            }
        },
        classFn(row) {
            let className = '';
            if (row.val > row.max) {
                className = 'higher-range';
            } else if (row.val < row.min) {
                className = 'lower-range';
            }
            return className;
        },
        getListFn() {
            this.$emit('getListFn', this.SearchForm);
        }
    }
};
</script>

<style lang="scss" scoped>
.table {
    flex: 1;

    .pagination {
        padding-top: 0;
        padding-right: 15px !important;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
</style>
